// 15-05-2025
import { getChargerById } from "../chargerAPI";
import { getTransaction } from "../transactionAPI";

/**
 * Makes a call to get the transaction
 * @param {string} id - to get the transaction valid "id" or by default "all" provides all the transaction
 * @param {string} type - to get the transaction of the type or  "*" for all the transaction
 * @returns - returns transaction data
 */
const handleGetTransaction = async (id) => {
  try {
    const response = await getTransaction(id);
    const { message, data } = response;
    return data;
  } catch (err) {
    if (err.isErr) {
      console.log("Error getting the Transaction ", err.msg);
      console.log("Problem: ", err.problem);
    } else {
      console.log("Unexpected Error: ", err);
    }
    return err;
  }
};

// get charger by chargerId: to get the perUnitRate
const handleGetChargerById = async (id) => {
  try {
    const data = await getChargerById(id);
    //   console.log("response chargerId: ", data);
    // const lasthb = response?.data?.lastHeartbeat;
    const { perUnitRate, name } = data;
    return { perUnitRate, name };
  } catch (err) {
    console.log("Error getting the chargersData: ", err.msg, id);
  }
};

//  to fetch all the transaction based on charger Ids under the host
export const loadTransactions = async (data) => {
  let transactions = [];
  let chargerWithData = {};
  await Promise.all(
    data.map(async (charger) => {
      try {
        const res = await handleGetTransaction(charger);
        if (!chargerWithData[charger]) {
          const chargerInfo = await handleGetChargerById(charger);
          chargerWithData[charger] = chargerInfo;
        }
        const { perUnitRate, name } = chargerWithData[charger];

        const transWithPerUnitRate = res.map((trans) => ({
          ...trans,
          perUnitRate,
          name, // inject rate here
        }));

        transactions.push(...transWithPerUnitRate);
      } catch (err) {
        console.log("Error loading transactions for ID", charger, err);
      }
    })
  );

  //Sort by StartTime
  transactions?.length > 0 &&
    transactions.sort((a, b) => {
      if (a.startTime && b.startTime) {
        return -a.startTime.localeCompare(b.startTime);
      }
      return 0; // or handle as necessary if startTime is missing
    });
  return transactions;
};
